import styled from 'styled-components';

import { animateIn, animateOut } from './utils';

export default styled.div`
  transition: opacity 0.3s, transform 0.3s;
  ${animateIn} {
    opacity: 1;
    transform: translateY(0);
  }
  ${animateOut} {
    opacity: 0;
    transform: translateY(32px);
  }
`;
